import { render, staticRenderFns } from "./NewPassenger.vue?vue&type=template&id=4a3e3b8d"
import script from "./NewPassenger.vue?vue&type=script&lang=js"
export * from "./NewPassenger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports